import React from 'react';

import classNames from "classnames";
import styles from "../../../styles/athlete-widget.placeholder.module.scss";
import {AthleteWidgetRowCompetitorsPlaceholder} from "./athlete-widget.row.competitors.placeholder";
import {AthleteWidgetRowScoresPlaceholder} from "./athlete-widget.row.scores.placeholder";

export const AthleteWidgetRowPlaceholder = () => {
  return (
    <div className={classNames(styles.row)}>
      <div className={classNames(styles.row_date)}/>
      <AthleteWidgetRowCompetitorsPlaceholder/>
      <AthleteWidgetRowScoresPlaceholder/>
      <div className={classNames(styles.row_min)}/>
      <div className={classNames(styles.row_icon)}/>
    </div>
  )
};